import React from 'react';

import { getImgixSrc } from '@utils/images';

import MobileStepWithMedia from '../MobileStepWithMedia';

interface ArticleShareProps {
  handleClose: () => void;
  handleNext: () => void;
  isProSubscriber: boolean;
  step: number;
  totalSteps?: number;
}

const ARTICLE_SHARE_IMAGE_SRC = getImgixSrc({
  path: 'tooltip/article_share.png',
  isEnvDependent: false,
});

const ArticleShare = ({
  handleClose,
  handleNext,
  isProSubscriber,
  step,
  totalSteps = 6,
}: ArticleShareProps) => (
  <MobileStepWithMedia
    description="Because you're a subscriber, you can share this article with anyone (3 reads)."
    handleClose={handleClose}
    handleNext={handleNext}
    isProSubscriber={isProSubscriber}
    media={
      <img
        src={ARTICLE_SHARE_IMAGE_SRC}
        alt="Share"
        className="h-full w-full object-cover object-top"
      />
    }
    showCloseButton={true}
    step={step}
    title="Share"
    totalSteps={totalSteps}
  />
);

export default ArticleShare;
